import { create } from 'zustand';

export interface ReactionPing {
  /** Counter so React keys are unique even when the same user spams the same emoji. */
  id: number;
  fromUserId: string;
  emoji: string;
  ts: number;
}

interface ReactionsState {
  /** All currently-visible reactions; consumers filter by fromUserId for badge bubbles. */
  active: ReactionPing[];
  push: (input: { fromUserId: string; emoji: string; ts: number }) => void;
  /** Drops reactions older than `now - olderThanMs`. Called by the rendering layer. */
  prune: (olderThanMs: number) => void;
  reset: () => void;
}

let counter = 0;

export const useReactions = create<ReactionsState>((set) => ({
  active: [],
  push: ({ fromUserId, emoji, ts }) =>
    set((s) => ({
      active: [...s.active, { id: ++counter, fromUserId, emoji, ts }],
    })),
  prune: (olderThanMs) =>
    set((s) => {
      const cutoff = Date.now() - olderThanMs;
      const next = s.active.filter((p) => p.ts > cutoff);
      return next.length === s.active.length ? s : { active: next };
    }),
  reset: () => set({ active: [] }),
}));
